import React from "react";
import Text from "../../components/Text";
import { fontSizes, pdfsPath } from "../../constants/constants";
import dynamicfunction from "../../utils/dynamicfunction";
import { informationSecurity, informationSecurityArabic } from "../../config/config";
import { ReactSVG } from "react-svg";
import ViewReverse from "../../components/ViewReverse";
import ViewItems from "../../components/ViewItems";
import icons from "../../constants/icons";

const InformationSecurity = () => {
  const { TextWeight, isArabic } = dynamicfunction();

  const content = isArabic ? informationSecurityArabic : informationSecurity;

  return (
    <div className="container mx-auto">
      <ViewReverse className={"w-full justify-between items-center"}>
        <Text
          text={content?.heading}
          color="text-primary"
          size={fontSizes.h24}
          weight={TextWeight.bold}
        />

        <a
          // href={isArabic ? pdfsPath.securityInfo_ar : pdfsPath.securityInfo_en}
          // download={pdfsPath.securityInfo_name}
        >
          <ViewReverse className={"gap-2 cursor-pointer"}>
            <ReactSVG src={icons.cloud} />
            <Text
              text={content?.download}
              color="text-primary"
              size={fontSizes.h14}
            />
          </ViewReverse>
        </a>
      </ViewReverse>

      {content?.content?.map((item, index) => (
        <ViewItems key={index} className={"mt-8"}>
          <Text
            text={item.title}
            size={fontSizes.h16}
            color="text-primary"
            weight={TextWeight.bold}
          />
          <Text
            text={item.content}
            size={fontSizes.h14}
            className={"mt-3"}
            style={{ whiteSpace: "pre-line" }}
          />
        </ViewItems>
      ))}
    </div>
  );
};

export default InformationSecurity;
